import { Snackbar as MuiSnackbar, Stack } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";

import { Alert } from "@/atoms";
import { closeAlert } from "@/redux/actions";

const Snackbar = () => {
    const dispatch = useDispatch();

    const open = useSelector((state) => state.alertReducer.open);

    const status = useSelector((state) => state.alertReducer.status);

    const closeSnackbarHandler = () => dispatch(closeAlert());

    return (
        <Stack spacing={2}>
            <MuiSnackbar
                autoHideDuration={6000}
                open={open}
                anchorOrigin={{
                    horizontal: "center",
                    vertical: "top",
                }}
                onClose={closeSnackbarHandler}
            >
                <Alert severity={status} onClose={closeSnackbarHandler} />
            </MuiSnackbar>
        </Stack>
    );
};

export default Snackbar;
